import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { AppState } from '../../../models/appState';
import { SavingParameters, ScheduleDate, Loan, Contribution, Parameter } from '@akiba/models_bimbo';
import { MatTabChangeEvent, MatSelectChange, MatDialog, MatTable, MatDatepickerInputEvent } from '@angular/material';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { LogicService } from '../../../services/logic.service';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { Moment } from 'moment';
import * as moment from 'moment';
import * as XlsxPopulate from 'xlsx-populate';
import { saveAs } from 'file-saver';
import { Helpers } from './../../../models/helpers';
import { take } from 'rxjs/operators';
import { UiService } from '../../../services/ui.service';
import { PendingLoanRequestLogicService } from '../../../services/pending-loan-request-logic.service';

@Component({
  selector: 'app-permanent-saving-investments',
  templateUrl: './permanent-saving-investments.component.html',
  styleUrls: ['./permanent-saving-investments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PermanentSavingInvestmentsComponent implements OnInit, OnDestroy {

  modParameter: Parameter | null = null;
  parameterSubscription: Subscription;
  savingParameters: Array<Parameter> = new Array<Parameter>();
  /** colaborador ahorrador o no ahorrador */
  savingAccount: Array<any> = [{ title: 'Ahorrador', value: true }, { title: 'No Ahorrador', value: false }];
  selectedSavingAccount: any;
  bankAdjustmentRelease: number = 0;
  //////////////////////////////////
  //////////////////////////////////
  @ViewChild('investmentsDatesTable', { static: false }) investmentsDatesTable: MatTable<ScheduleDate>;
  displayedLoanDatesColumns: string[] = ['InicioInversion', 'FinInversion', 'active', 'delete'];

  selectedIndex = 0;
  uploadSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;
  contentLocation: AppState = new AppState();
  tempPeriod: Parameter;
  disabledSaving: boolean;
  isEdit = false;

  loanList: Array<any>;
  format = 'DD-MMM-YYYY';
  reportDate = new ScheduleDate();
  employeesLoanListHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeRef.employeeNumber' },
    { title: 'monto', property: 'requestedAmount' },
    { title: 'totalCuotas', property: 'requestedNumberOfPayments' },
    { title: 'porcentageInteres', property: 'interestPercentage' },
    { title: 'fechaAprobacion', property: 'createDate' },
    { title: 'tipo', property: 'type' },
    { title: 'estatus', property: 'status' },
    { title: 'loanID', property: 'loanID' },

  ];

  employeesLoanListHeaderTotal: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'monto', property: 'requestedAmount' },
    { title: 'totalCuotas', property: 'requestedNumberOfPayments' },
    { title: 'porcentajeInteres', property: 'interestPercentage' },
    { title: 'fechaAprobacion', property: 'requestDate' },
    { title: 'loanID', property: 'loanID' },
  ];


  newRLoanDateSavers = new ScheduleDate();
  newRLoanDateNonSavers = new ScheduleDate();
  startdate = moment().subtract(4, "days").format("YYYY-MM-DD");
  disabledLoanListT : boolean = true;

  constructor(private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public logicService: LogicService, private ui: UiService, private pendingLoans: PendingLoanRequestLogicService) {
    if (!this.logicService.dataManager.parameterDataLoader.parameters) {

      this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

        if (p && p.response) {
          this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 2);
        }

      });

      this.logicService.dataManager.parameterDataLoader.load();

    } else {

      this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 2);

    }
  }

  async ngOnInit() {
    this.reset();
      // aqui vamos a crear el archivo
      const  buttonLoadLoan: firebase.database.DataSnapshot | null = await this.dataService.reportFromLog(this.startdate);

        if (buttonLoadLoan) {
          this.disabledLoanListT = buttonLoadLoan.val() == null ? true : false;
        }
        console.log('buttonLoadLoan', this.disabledLoanListT);
    ///////////
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  currencyInputChanged(value: string) {

    const num = value.replace(/[$,]/g, '');
    const intValue = Number(num);
    return intValue;

  }

  selectedPeriodChange(event: MatSelectChange) {
    if (!event.value) {
      this.reset();
    } else {
      this.modParameter = event.value;
      this.isEdit = true;
      this.tempPeriod = event.value;
    }

  }

  selectedSaving(event: MatSelectChange) {

    if (!event.value) {
      this.reset();
    } else {
      this.selectedSavingAccount = event.value;
      this.isEdit = true;
    }

  }

  selectSavingPeriod(event: MatSelectChange) {

    if (!event.value) {
      this.reset();
    } else {
      /** mostrar el parametro que corresponde a si es ahorrador o no  */
      let saving = event.value;
      if (saving.value == true) {
        this.disabledSaving = true;
      } else {
        this.disabledSaving = false;

      }

    }


  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;
  }

  procPendingListLoans() {
    const mountMax: number = 5000000;

    if (this.selectedSavingAccount == undefined) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario seleccionar un Tipo de Cuenta',
          close: 'Aceptar'
        }
      });
      return;
    }

    if (this.bankAdjustmentRelease > mountMax) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto máximo para su liberación no debe exceder a $5,000,000',
          close: 'Aceptar'
        }
      });
      return;
    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea liberar los préstamos en lista de espera que no superen el monto acumulado de $ ' + this.bankAdjustmentRelease.toFixed(2) + ' ?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        let response: any;
        let totalAmount = 0;
        let totalLoan = 0;
        this.ui.showSpinner();
        let availableAmountForPendingList = this.bankAdjustmentRelease;
        let textTotal = this.bankAdjustmentRelease;
        this.bankAdjustmentRelease = 0.0;
        let appliedAmount = 0;
        let remainingAmount = 0;
        let accumulatedAmount = 0;

        if (availableAmountForPendingList > 0 && availableAmountForPendingList <= mountMax) {

          await this.procLoan(availableAmountForPendingList, accumulatedAmount).then(res => {
            appliedAmount = res.appliedAmount;
            remainingAmount = res.remainingAmount;
            totalLoan = res.loanIDs.length
            this.loanList = res.loanIDs;


          }).catch(error => {
            console.log('error', error);
          });

        } else {
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: "el monto no debe superar los $5,000,000.00",
              close: 'Aceptar'
            }
          });

        }

        totalAmount = textTotal - remainingAmount;
        this.bankAdjustmentRelease = 0;

        let textMessage = totalLoan === 0 ? 'Se activaron ' + totalLoan.toString() + ' con un remanente de $ ' + textTotal
          + ' Tipo de cuenta: ' + this.selectedSavingAccount.title : 'Se activaron ' + totalLoan.toString() + ' préstamos por un total de $ ' + totalAmount.toFixed(2)
          + ' con un remanente de $ ' + remainingAmount.toFixed(2)
          + ' Tipo de cuenta: ' + this.selectedSavingAccount.title;

        this.ui.stopSpinner();

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: textMessage,
            close: 'Aceptar'
          }
        });

      }
    });

  }


  async reporteLoanList() {
    let _suraAmount: number = 0;
    let type = 'employeesLoanList';

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.employeesLoanListHeader);
    let row = 5;
    let mapped = new Array<any>();
    if (this.loanList.length > 0) {

      for (const iterator of this.loanList) {

        const loadLoan: any = await this.dataService.loadLoan(iterator).pipe(take(1)).toPromise().catch(error => {
          console.log(error);
          return [];
        });
        loadLoan.createDate = loadLoan.createdAt.toDate();
        loadLoan.interestPercentage = loadLoan.interestPercentage ? loadLoan.interestPercentage * 100 : 0;

        this.buildReport(xlsx, this.employeesLoanListHeader, loadLoan, row);
        row++;

      }

    }

    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });
  }


 async reportTotal(){
    let type = 'LoanListTotal';
    console.log('iterator', this.startdate);

    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.employeesLoanListHeaderTotal);
    let row = 5;
      // aqui vamos a crear el archivo

        let loadLoan: firebase.database.DataSnapshot | null = await this.dataService.reportFromLog(this.startdate);
        if (loadLoan) {

          const values: any = loadLoan.exists() ? loadLoan.val() : null;
          loadLoan = null;
          if (values) {
    
            const keys = Object.keys(values);
            for (const key of keys) {
              let record: any = values[key];
              if (record) {
                record.interestPercentage = record.interestPercentage ? record.interestPercentage * 100 : 0;
                record.requestDate = String(record.requestDate).substring(0,10);
                
              this.buildReport(xlsx, this.employeesLoanListHeaderTotal, record, row);
              row++;
              }
            }
          } 
    
        } else {

          this.buildReport(xlsx, this.employeesLoanListHeader, [], row);

        }


    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });
  }


  async procLoan(amountPendingList: number, accumulatedAmount: number) {
    let dataPendingList: any;
    let parameter = this.modParameter.parametersID;

    dataPendingList = {
      originalAmount: amountPendingList,
      totalAccumulatedAmount: accumulatedAmount,
      savingList: this.selectedSavingAccount.value,
      parameterID: parameter
    };

    const response = await this.dataService.postLoansPendingList(dataPendingList).catch(error => console.log(error));
    return response;

  }


  saveEditedPeriod() {

  /*  if (!this.modParameter.investmentParameterSavers.investmentDates.length || !this.modParameter.investmentParameterNonSavers.investmentDates.length) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fechas del ciclo son requeridas',
          close: 'Aceptar'
        }
      });
      return;
    }
*/
    if (this.selectedSavingAccount == undefined) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario seleccionar un Tipo de Cuenta',
          close: 'Aceptar'
        }
      });
      return;
    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {

        this.modParameter.investmentParameterSavers.theoreticalAvailableAmount += this.modParameter.investmentParameterSavers.bankAdjustment;
        this.modParameter.investmentParameterNonSavers.theoreticalAvailableAmount += this.modParameter.investmentParameterNonSavers.bankAdjustment;
        this.modParameter.investmentParameterSavers.bankAdjustment = 0;
        this.modParameter.investmentParameterNonSavers.bankAdjustment = 0;

        const aPeriodObj = this.modParameter.toAny();

        let result = true;
        await this.dataService.saveParameter(aPeriodObj).catch(error => {
          result = false;
        });

        if (result) {

          this.contentLocation.savingParametersIndex = 0;
          this.reset();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'La información ha sido actualizada',
              close: 'Aceptar'
            }
          });

        } else {

          this.reset();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'No fue posible actualizar la información',
              close: 'Aceptar'
            }
          });

        }

      } else {

        this.reset();
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'No fue posible actualizar la información',
            close: 'Aceptar'
          }
        });

      }

    });

  }

  cancelEditPeriod() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
      }
    });

  }


  async addDateSavers() {

    if (!this.newRLoanDateSavers.startDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha de inicio de ciclo es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.newRLoanDateSavers.endDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha fin de ciclo es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    this.newRLoanDateSavers.active = true;
    this.modParameter.investmentParameterSavers.investmentDates.push(this.newRLoanDateSavers);
    this.newRLoanDateSavers = new ScheduleDate();
    this.newRLoanDateSavers.startDate = null;
    this.newRLoanDateSavers.endDate = null;

    if (this.investmentsDatesTable) {
      this.investmentsDatesTable.renderRows();
    }
  }

  async addDateNonSavers() {

    if (!this.newRLoanDateNonSavers.startDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha de inicio de ciclo es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.newRLoanDateNonSavers.endDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha fin de ciclo es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    this.newRLoanDateNonSavers.active = true;
    this.modParameter.investmentParameterNonSavers.investmentDates.push(this.newRLoanDateNonSavers);
    this.newRLoanDateNonSavers = new ScheduleDate();
    this.newRLoanDateNonSavers.startDate = null;
    this.newRLoanDateNonSavers.endDate = null;

    if (this.investmentsDatesTable) {
      this.investmentsDatesTable.renderRows();
    }
  }



  setCycleDateSavers(type: string, event: MatDatepickerInputEvent<Moment>) {

    if (type === 'starts') {

      this.newRLoanDateSavers.startDate = event.value.toDate();
      const nextDay = moment(event.value);
      this.newRLoanDateSavers.endDate = nextDay.add(1, 'days').toDate();

      this.newRLoanDateSavers.weekNumber = event.value.isoWeek();
      const isoWeek = event.value.isoWeek() / 2;
      this.newRLoanDateSavers.biWeekNumber = Math.ceil(isoWeek);

    } else if (type === 'ends') {

      this.newRLoanDateSavers.endDate = event.value.toDate();

    }

  }

  setCycleDateNonSavers(type: string, event: MatDatepickerInputEvent<Moment>) {

    if (type === 'starts') {

      this.newRLoanDateNonSavers.startDate = event.value.toDate();
      const nextDay = moment(event.value);
      this.newRLoanDateNonSavers.endDate = nextDay.add(1, 'days').toDate();

      this.newRLoanDateNonSavers.weekNumber = event.value.isoWeek();
      const isoWeek = event.value.isoWeek() / 2;
      this.newRLoanDateNonSavers.biWeekNumber = Math.ceil(isoWeek);

    } else if (type === 'ends') {

      this.newRLoanDateNonSavers.endDate = event.value.toDate();

    }

  }

  async calculateInvestment() {

    let current: any;
    if (this.selectedSavingAccount.value == true) {
      current = this.modParameter.investmentParameterSavers.investmentDates.filter(e => e.active );
    } else {
      current = this.modParameter.investmentParameterNonSavers.investmentDates.filter(e => e.active);
    }

    if (current.length === 1) {


    //  this.ui.showSpinner();

      const sPeriod = current[0];
      const loansResult = await combineLatest([
        this.dataService.loadAllEmployeesLoansApproved(sPeriod.startDate, sPeriod.endDate), 
        this.dataService.loadAllContributions('CAL_SURA', sPeriod.startDate.getTime(), sPeriod.endDate.getTime()), 
        this.dataService.loadAllContributions('CAL', sPeriod.startDate.getTime(), sPeriod.endDate.getTime())
       ]).pipe(take(1)).toPromise();

      const loans = loansResult[0].docs.map(e => new Loan(e.data())).filter(e => e.type === 'permanent');
      const totalInLoans = loans.map(e => {
        return e.requestedAmount;
      }).reduce((p, n) => p + n, 0);


      const contributionsW = loansResult[2].map(e => new Contribution(e)).map(c => c.employeeWithdraw + c.companyWithdraw).reduce((p, n) => p + n, 0);

      const paid = loans.map(loan => loan.scheduleDates.values().filter(sd => sd.paid)).reduce((p, n) => p.concat(n), []).map(e => e.capital).reduce((p, n) => p + n, 0);
      const pending = totalInLoans - paid;

      if (this.selectedSavingAccount.value == true) {
        this.modParameter.investmentParameterSavers.loansRefundAmount = pending;
        this.modParameter.investmentParameterSavers.refunds = contributionsW;
      } else {
        this.modParameter.investmentParameterNonSavers.loansRefundAmount = pending;
        this.modParameter.investmentParameterNonSavers.refunds = contributionsW;
      }



      this.ui.stopSpinner();

    } else if (current.length > 1) {

      if (this.selectedSavingAccount.value == true) {
        this.modParameter.investmentParameterSavers.loansRefundAmount = 0;
        this.modParameter.investmentParameterSavers.theoreticalAvailableAmount = 0;
        this.modParameter.investmentParameterSavers.refunds = 0;
      } else {
        this.modParameter.investmentParameterNonSavers.loansRefundAmount = 0;
        this.modParameter.investmentParameterNonSavers.theoreticalAvailableAmount = 0;
        this.modParameter.investmentParameterNonSavers.refunds = 0;
      }

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible calcular la inversión debido a que hay mas de una fecha activa.',
          close: 'Aceptar'
        }
      });
      return;

    } else {
      if (this.selectedSavingAccount.value == true) {
        this.modParameter.investmentParameterSavers.loansRefundAmount = 0;
        this.modParameter.investmentParameterSavers.theoreticalAvailableAmount = 0;
        this.modParameter.investmentParameterSavers.refunds = 0;
      } else {
        this.modParameter.investmentParameterNonSavers.loansRefundAmount = 0;
        this.modParameter.investmentParameterNonSavers.theoreticalAvailableAmount = 0;
        this.modParameter.investmentParameterNonSavers.refunds = 0;
      }


      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible calcular la inversión debido a que no hay una fecha activa.',
          close: 'Aceptar'
        }
      });
      return;

    }

  }

  deleteDate(index: number) {

    if (this.selectedSavingAccount.value == true) {
      this.modParameter.investmentParameterSavers.investmentDates.splice(index, 1);
    } else {
      this.modParameter.investmentParameterNonSavers.investmentDates.splice(index, 1);
    }

    this.investmentsDatesTable.renderRows();
  }


  buildReportHeader(xlsxRef: any, type: string, subTypes: Array<string> | null, headers: Array<any>) {

    const fStart = moment(this.reportDate.startDate).locale('es').format(this.format);
    const fEnd = moment(this.reportDate.endDate).locale('es').format(this.format);

    xlsxRef.sheet(0).row(1).cell(2).value(fStart);
    xlsxRef.sheet(0).row(2).cell(2).value(fEnd);

    let title = type;
    if (subTypes) {
      title = subTypes.join(' / ');
    }

    xlsxRef.sheet(0).row(3).cell(1).value(title);

    const headerRef = xlsxRef.sheet(0).row(4);
    let headerCellIndex = 1;
    for (const header of headers) {
      const cell = headerRef.cell(headerCellIndex);
      this.buildCell(cell, header.title);
      headerCellIndex++;
    }

  }

  buildReport(xlsxRef: any, headers: Array<any>, data: any, row: number) {

    const rowRef = xlsxRef.sheet(0).row(row);

    let cellIndex = 1;
    for (const header of headers) {
      const cell = rowRef.cell(cellIndex);
      this.buildCell(cell, header.property, data);
      cellIndex++;
    }

  }


  buildCell(cell: XlsxPopulate.Cell, property: string, data: any = null) {

    if (data) {
      const properties = property.split('.');
      const value = this.searchPropertyValue(properties, data);

      if (!Helpers.isObject(value)) {

        cell.value(value);

      } else {

        try {

          if (Helpers.isDate(value)) {
            const aDate = moment(value).locale('es').format(this.format);
            cell.value(aDate);
          } else if (typeof value.toDate === 'function') {

            const time = moment.unix(value.seconds).utc(true);
            const year = time.year();
            const month = time.month();
            const day = time.date();
            const newD = new Date(year, month, day);
            const aDate = moment(newD).locale('es').format(this.format);
            cell.value(aDate);

          } else {
            cell.value('-');
          }

        } catch (error) {
          cell.value('-');
        }

      }

    } else {
      cell.value(property);
    }

  }

  searchPropertyValue(propertyNames: Array<string>, object: any): any {

    if (propertyNames.length) {

      const pName = propertyNames.splice(0, 1)[0].trim();

      if (object.hasOwnProperty(pName)) {
        const childObject = object[pName];
        return this.searchPropertyValue(propertyNames, childObject);
      }

    }

    return object;

  }

  reset() {
    this.modParameter = new Parameter();
    this.contentLocation.savingParametersIndex = 0;
    this.isEdit = false;
    this.tempPeriod = null;
    this.loanList = null;

    this.newRLoanDateSavers = new ScheduleDate();
    this.newRLoanDateSavers.startDate = null;
    this.newRLoanDateSavers.endDate = null;
    this.newRLoanDateSavers.scheduleDay = null;

    this.newRLoanDateNonSavers = new ScheduleDate();
    this.newRLoanDateNonSavers.startDate = null;
    this.newRLoanDateNonSavers.endDate = null;
    this.newRLoanDateNonSavers.scheduleDay = null;

  }

  ngOnDestroy(): void {
    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

  }

}
